

import { rendererRegistry } from './renderers/RendererRegistry';
import { ExtensionDefinition, PageBlueprint, createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityContentBlueprint } from '@backstage/plugin-catalog-react/alpha';
import ExtensionIcon from '@material-ui/icons/Extension';


const externalEntityIntegrationsPage = PageBlueprint.make({
    params: {
        path: '/external-entity-integration',
        loader: () => import('./components/ExternalEntityIntegrationPage').then(m => <m.ExternalEntityIntegrationPage />),
    },
});

export const externalEntityIntegrationContent: ExtensionDefinition = EntityContentBlueprint.make({
    name: 'external-integration',
    params: {
        path: '/external-entity-integration',
        title: 'External Integration',
        loader: () => import('./components/ExternalEntityIntegrationContent').then(m => <m.ExternalEntityIntegrationsContent />),
    }
});

export const externalEntityIntegrationPlugin = createFrontendPlugin({
  pluginId: 'external-entity-integration',
  title: 'External Entity Integration',
  icon: <ExtensionIcon />,
  extensions: [
      externalEntityIntegrationsPage,
      externalEntityIntegrationContent,
  ],
});

export { rendererRegistry };
